
import { IErrorStore } from "../../../error/types";

import type { TFieldKey } from "@./suf-store";
import type { IBaseStoreState } from "../../shared/baseStore.types";

import type { DirectSalesFlowSlug } from "./constants";


export interface IDirectSalesViewState {
  checkout: {
    showManualEntryButton: boolean
    showAddressSelect: boolean,
    showShippingAddressFields: boolean,
    hasClickedFindAddress: boolean,
    isDeliveryComplete: boolean,
    hasCompletedDeliveryOnce: boolean,
    hasSelectedAddressFromLookup: boolean,
    showShippingAddressWarning: boolean,
    showBillingAddressFields: boolean,
    billingSameAsShipping: boolean,
    showProcessingModal: boolean,
    shouldTriggerPayment: boolean,
  },
}

export enum TargetUser {
  CUSTOMER = "CUSTOMER",
  BRAND_AMBASSADOR = "BRAND_AMBASSADOR",
}

export interface IDirectSalesSignupFlowStore extends IBaseStoreState {
  viewState: IDirectSalesViewState;
  updateViewState(view: string, params: Record<string, unknown>, catId?: string): void;
  sufQuizVersion: number;
  resetSignupFlow(): void;
  cardReaderId: string;
  setCardReaderId(id: string): void;
  targetUser: TargetUser
  setTargetUser(target: TargetUser): void;
}

export type IDirectSalesSignupFlowErrorStore = IErrorStore<TFieldKey, DirectSalesFlowSlug>;
